import { computed, ref, type Ref } from "vue";
import {
  localStorageGetChainCode,
  localStorageGetCustomerCode,
  localStorageGetShopCode,
} from "@/common/localStorageUtil";
import { getWordList } from "@/common/graphql/expression";
import { getChainInfo } from "@/common/graphql/chain";
import { getCityByPrefGroupedByStepA } from "@/common/graphql/cityByPref";
import { TMP_MEMBER_LIST_FILE_NAME } from "../constants";

/**
 * composableへ渡す依存をまとめた型。
 */
interface UseTmpMemberInitParams {
  initTableHeaders: () => void;
  getDeliveryAvailable: () => Promise<void>;
  errdialog: Ref<boolean>;
  errMessage: Ref<string>;
  prefSelectValue: Ref<string>;
  cityBlockList: Ref<any>;
  originalAddress: Ref<string>;
}

/**
 * 画面ロジックを扱う composable。
 */
export const useTmpMemberInit = (params: UseTmpMemberInitParams) => {
  const {
    initTableHeaders,
    getDeliveryAvailable,
    errdialog,
    errMessage,
    prefSelectValue,
    cityBlockList,
    originalAddress,
  } = params;

  // 文言データ
  const wordList = ref<Record<string, string>>({});
  const requiredFieldLabelKeys = [
    "lbl_name_kanji_kana",
    "lbl_tel",
    "lbl_zipcode",
  ] as const;

  const isWordListReady = computed(() => {
    if (Object.keys(wordList.value).length === 0) return false;
    return requiredFieldLabelKeys.every((key) => key in wordList.value);
  });

  const runInitialLoad = async (): Promise<void> => {
    try {
      wordList.value = await getWordList(localStorageGetChainCode(), TMP_MEMBER_LIST_FILE_NAME, localStorageGetCustomerCode());
      originalAddress.value = prefSelectValue.value;
      if (prefSelectValue.value !== "") {
        cityBlockList.value = await getCityByPrefGroupedByStepA(localStorageGetCustomerCode(), localStorageGetChainCode(), localStorageGetShopCode(), prefSelectValue.value);
      }
      const result = await getChainInfo(localStorageGetCustomerCode(), localStorageGetChainCode());
      initTableHeaders();
    } catch (err: unknown) {
      console.error(err);
      errdialog.value = true;
      errMessage.value = err instanceof Error ? err.message : "予期せぬエラーが発生しました。";
      return;
    }
    getDeliveryAvailable();
  };

  return {
    wordList,
    isWordListReady,
    runInitialLoad,
  };
};
